 // Styling specific to the new (AI / workspace.*) planning UI.
// This file exists specifically so the legacy planning UI can remain unchanged.

const NewPlanStyle = {
  // Header purple from the wireframe (fresh-start)
  headerPurple: '#6b4f8a',

  filterHeader: {
    display: 'flex',
    alignCenter: 'center',
    justifyContent: 'space-between',
    width: '100%',
    borderBottom: 2,
    borderColor: '#ebecf1',
  },

  textFields: {
    background: '#6b4f8a',
    borderRadius: '5px 5px 0 0',
    overflow: 'hidden',
  },

  highlightCol: {
    background: '#6b4f8a',
    color: '#fff',
    textAlign: 'center !important',
  },

  highlightRow: {
    background: '#e6e1eb',
    textAlign: 'center',
  },
}

export default NewPlanStyle

